
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 317.2 675.36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-128.12 498.8a20.48 20.48 0 00-20.48 20.48v125.6a20.48 20.48 0 0020.48 20.48h573.44a20.48 20.48 0 0020.48-20.48v-125.6a20.48 20.48 0 10-40.96 0V624.4h-532.48V519.28a20.48 20.48 0 00-20.48-20.48z"}}),_c('path',{attrs:{"d":"M158.6 10a20.48 20.48 0 00-20.48 20.48V471L8.22 345.52a20.473 20.473 0 10-28.447 29.45l164.31 158.74.041.041.246.225c.758.738 1.72 1.045 2.54 1.639 1.27.921 2.457 1.945 3.931 2.54a20.255 20.255 0 0015.483 0c1.373-.554 2.458-1.516 3.646-2.356.942-.635 2.007-1.024 2.847-1.843l164.58-159.03a20.487 20.487 0 00-28.488-29.45l-129.82 125.52V30.476a20.48 20.48 0 00-20.48-20.48z"}})])
          )
        }
      }
    